import mitt, { Emitter } from 'mitt';

const emitter: Emitter<any> = mitt();

// EB = EVENT_BUS
export enum EB_EVENT_NAME {
  LIVE_OPEN = 'LIVE_OPEN', // 直播开启
  LIVE_CLOSE = 'LIVE_CLOSE', // 直播关闭
  LIVE_BLOCK = 'LIVE_BLOCK', // 直播封禁
  LIVE_REFRESH = 'LIVE_REFRESH', // 封禁后刷新

  // 弹幕组件事件
  COMMENT_SENT = 'COMMENT_SENT', // 发送弹幕
  COMMENTS_CONTAINER_RESIZED = 'COMMENTS_CONTAINER_RESIZED', // 弹幕容器大小变化
  COMMENTS_RECEIVED = 'COMMENTS_RECEIVED', // 接收到弹幕信息
  COMMENTS_SCROLL_BOTTOM = 'COMMENTS_SCROLL_BOTTOM', // 弹幕容器滚动到底部
  COMMENTS_SCROLLING = 'COMMENTS_SCROLLING', // 弹幕容器滚动事件

  // 充值支付事件
  PAYMENT_DIALOG_OPEN = 'PAYMENT_DIALOG_OPEN',
  PAYMENT_DIALOG_CLOSE = 'PAYMENT_DIALOG_CLOSE',
  PAYMENT_DIALOG_SUCCESS_PAYED = 'PAYMENT_DIALOG_SUCCESS_PAYED',
  PAYMENT_DIALOG_FAILED_PAYED = 'PAYMENT_DIALOG_FAILED_PAYED',

  // 贡献排行榜
  RANK_TOP_USERS = 'RANK_TOP_USERS', // top3用户发生变化

  // 登录
  NEED_LOGIN = 'NEED_LOGIN', // 直播间内触发登录框

  // 特效展现
  COMBO_RECEIVED = 'COMBO_RECEIVED', // 接收到连击信息
  ROOM_WARNING_SHOW = 'ROOM_WARNING_SHOW', // 房间警告展现
  ROOM_WARNING_HIDE = 'ROOM_WARNING_HIDE', // 房间警告隐藏
  ROOM_WARNING_SET = 'ROOM_WARNING_SET', // 房间警告设置
  EFFECT_RECEIVED = 'EFFECT_RECEIVED', // 接收到礼物特效信息
  EFFECT_START = 'EFFECT_START', // 开始动画消费

  // 用户卡片、举报卡片 
  CLOSE_CARDS = 'CLOSE_CARDS', // 卡片类全局关闭

  // 全局弹框
  OPEN_ADMIN_MODAL = 'OPEN_ADMIN_MODAL', // 打开管理员弹窗
  OPEN_MUTE_MODAL = 'OPEN_MUTE_MODAL', // 打开禁言弹窗
  OPEN_REPORT_MODAL = 'OPEN_REPORT_MODAL', // 打开举报弹窗
  OPEN_WARNING_MODAL = 'OPEN_WARNING_MODAL', // 打开超管告警弹窗

  // 充能条广播
  RECHARGE_BAR_INFO = 'RECHARGE_BAR_INFO'
}


export interface ILiveBlockData {
  notice: string,
  end_time: number,
}

export interface IOpenMuteModalData {
  roomId: number,
  mid: number,
  username: string,
  muteState: number,
};

export interface IOpenAdminModalData {
  roomId: number,
  mid: number,
  username: string,
  adminState: number,
};

export interface IOpenReportModalData {
  roomId?: number, // for type === room
  mid?: number, // for type === comment
  type: 'room' | 'comment',
  reason?: string
};


export interface IOpenWarningModalData {
  duration: number,
  title: any[],
  content: any[],
};

export default emitter;